export default __webpack_public_path__ + "images/man.52a5f2bb4987ee53010ea69d5fbfff46.png";